module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope"
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Projetos")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Projetos',
        href: '#'
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title cursor_pointer",
    on: {
      "click": function($event) {
        _vm.mostrarCabecalhoProjeto = !_vm.mostrarCabecalhoProjeto
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrarCabecalhoProjeto ? 'right' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Projeto "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarCabecalhoProjeto),
      expression: "!mostrarCabecalhoProjeto"
    }]
  }, [_vm._v(_vm._s(_vm.projeto.proposal.idProjectErp) + " - " + _vm._s(_vm.projeto.proposal.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarCabecalhoProjeto),
      expression: "mostrarCabecalhoProjeto"
    }],
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('legend', [_vm._v("Projeto")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {}, [_vm._v("Número do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "idProjectErp",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.idProjectErp),
      expression: "projeto.proposal.idProjectErp"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": true,
      "name": "idProjectErp"
    },
    domProps: {
      "value": (_vm.projeto.proposal.idProjectErp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "idProjectErp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {}, [_vm._v("Nome do projeto ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.name),
      expression: "projeto.proposal.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.projeto.proposal.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('legend', [_vm._v("Responsável pela Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorName",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.coordinatorName),
      expression: "projeto.proposal.coordinatorName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome do coordenador",
      "type": "text"
    },
    domProps: {
      "value": (_vm.projeto.proposal.coordinatorName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "coordinatorName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 required"
  }, [_c('label', {}, [_vm._v("CPF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorCpf",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('cpf|required'),
      expression: "'cpf|required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf do coordenador",
      "type": "text",
      "mask": '###.###.###-##'
    },
    model: {
      value: (_vm.projeto.proposal.coordinatorCpf),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "coordinatorCpf", $$v)
      },
      expression: "projeto.proposal.coordinatorCpf"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {}, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorEmail",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.coordinatorEmail),
      expression: "projeto.proposal.coordinatorEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email do coordenador",
      "type": "email"
    },
    domProps: {
      "value": (_vm.projeto.proposal.coordinatorEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "coordinatorEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {}, [_vm._v("Telefone")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Telefone",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.coordinatorPhone),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "coordinatorPhone", $$v)
      },
      expression: "projeto.proposal.coordinatorPhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {}, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Celular",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.coordinatorMobile),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "coordinatorMobile", $$v)
      },
      expression: "projeto.proposal.coordinatorMobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {}, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.coordinatorPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Fax",
      "type": "tel",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.coordinatorFax),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "coordinatorFax", $$v)
      },
      expression: "projeto.proposal.coordinatorFax"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-md-offset-1"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Dados da Entidade")]), _vm._v(" "), _c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Entidade")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.projeto.proposal.entity.companyName))]), _vm._v(" "), _c('dt', [_vm._v("Endereço")]), _vm._v(" "), _c('dd', _vm._l((_vm.projeto.proposal.entity.address), function(addr) {
    return _c('address', {
      staticClass: "ng-binding ng-scope"
    }, [_vm._v("\n                                        " + _vm._s(addr.street) + " "), _c('br'), _vm._v("\n                                        " + _vm._s(addr.neighbourhood) + " - " + _vm._s(addr.city) + " / " + _vm._s(addr.state) + "\n                                      ")])
  }), 0), _vm._v(" "), _c('dt', [_vm._v("E-mail")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.projeto.proposal.entity.email))])]), _vm._v(" "), _c('h2', {
    staticClass: "h4"
  }, [_vm._v("Período de execução do projeto")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-12 ng-scope",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('label', {}, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.initialDate",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.initialDate),
      expression: "projeto.proposal.initialDate"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-isolate-scope ng-valid-maxlength ng-valid-date ng-valid-mask ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "Data Inicial",
      "type": "date",
      "placeholder": "__/__/____"
    },
    domProps: {
      "value": (_vm.projeto.proposal.initialDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "initialDate", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {}, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.periods",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.periods),
      expression: "projeto.proposal.periods"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-invalid ng-not-empty ng-invalid-min ng-valid-required",
    attrs: {
      "name": "periodo",
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.projeto.proposal.periods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "periods", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dl', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin-left": "-15px"
    }
  }, [_c('dt', [_vm._v("Data final de execução:")]), _vm._v(" "), _c('dd', {
    staticClass: "ng-binding"
  }, [_vm._v(_vm._s(_vm.dataFinal))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(this.$root.isFundacao(this.usuarioLogado)) ? _c('visualiza-timeline', {
    attrs: {
      "numeroProjeto": _vm.projeto.proposal.idProjectErp,
      "atualizar": _vm.atualizar_timeline
    },
    on: {
      "idAcompanhamento": function($event) {
        _vm.filtro_acompanhamento = $event
      },
      "idAlteracoes": function($event) {
        _vm.filtro_alteracoes = $event
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
    ref: "acompanhamento",
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('acompanhamentoProjetos', {
    attrs: {
      "ParmProjetos": _vm.projeto,
      "ParmAcompanhamento": _vm.acProp,
      "filtro": _vm.filtro_acompanhamento
    },
    on: {
      "atualizarTimeline": function($event) {
        _vm.atualizar_timeline = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$root.isFundacao(this.usuarioLogado)) ? _c('div', {
    ref: "alteracoes",
    staticClass: "col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('alteracoesProjetos', {
    attrs: {
      "ParmProjetos": _vm.projeto,
      "ParmAlteracao": _vm.atProp,
      "filtro": _vm.filtro_alteracoes
    },
    on: {
      "atualizarTimeline": function($event) {
        _vm.atualizar_timeline = $event
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope",
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('INTRODUCTION')"
    }
  }, [_c('label', {
    staticClass: " ",
    attrs: {
      "for": "introduction"
    }
  }, [_vm._v("Introdução")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.introduction",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.introduction),
      expression: "projeto.proposal.introduction"
    }],
    staticClass: "form-control ng-pristine ng-scope ng-not-empty ng-valid ng-valid-required ng-touched",
    attrs: {
      "name": "introducao",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.introduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "introduction", $event.target.value)
      }
    }
  }, [_vm._v("<!---->\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {
    attrs: {
      "for": "presentation"
    }
  }, [_vm._v("Apresentação")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.presentation",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.presentation),
      expression: "projeto.proposal.presentation"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "apresentacao",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.presentation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "presentation", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {
    attrs: {
      "for": "territory"
    }
  }, [_vm._v("Território de desenvolvimento do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.territory",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.territory),
      expression: "projeto.proposal.territory"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "territorio",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.territory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "territory", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {
    attrs: {
      "for": "justification"
    }
  }, [_vm._v("Justificativa")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.justification",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.justification),
      expression: "projeto.proposal.justification"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "justificativa",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.justification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "justification", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {
    attrs: {
      "for": "generalObjective"
    }
  }, [_vm._v("Objetivo geral")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.generalObjective",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.generalObjective),
      expression: "projeto.proposal.generalObjective"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "objetivo Geral",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.generalObjective)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "generalObjective", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12 ng-scope"
  }, [_c('label', {
    attrs: {
      "for": "summary"
    }
  }, [_vm._v("Resumo")]), _vm._v(" "), _c('div', {
    staticClass: "ng-isolate-scope",
    attrs: {
      "name": "proposal.summary",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.summary),
      expression: "projeto.proposal.summary"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-scope ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "sumario",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "summary", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(3), _vm._v(" "), _c('publicoAlvoOld', {
    attrs: {
      "propsPublicosGrid": this.projeto.proposal.audiences
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(4), _vm._v(" "), _c('equipe-projetoOld', {
    attrs: {
      "propsEquipes": this.projeto.proposal.teams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('Resultados esperados')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "results"
    }
  }, [_vm._v("Resultados esperados")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.results",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.results),
      expression: "projeto.proposal.results"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Resultados esperados",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.results)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "results", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('Operacionalização')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("Operacionalização")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.operation",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.operation),
      expression: "projeto.proposal.operation"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Operacionalização",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.operation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "operation", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "partner"
    }
  }, [_vm._v("Parceria")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.partner",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.partner),
      expression: "projeto.proposal.partner"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Parceria",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.projeto.proposal.partner)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "partner", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v("A proponente será a executora do projeto?")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityIsExecutioner",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityIsExecutioner),
      expression: "projeto.proposal.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-true",
      "value": "true",
      "selected": _vm.projeto.proposal.entityIsExecutioner === 'true'
    },
    domProps: {
      "checked": _vm._q(_vm.projeto.proposal.entityIsExecutioner, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.projeto.proposal, "entityIsExecutioner", "true")
      }
    }
  }), _vm._v(" Sim\n                                  ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline control-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityIsExecutioner),
      expression: "projeto.proposal.entityIsExecutioner"
    }],
    attrs: {
      "type": "radio",
      "name": "entityExecutingBool",
      "id": "proposal-entity-executing-false",
      "value": "false",
      "selected": _vm.projeto.proposal.entityIsExecutioner === 'false'
    },
    domProps: {
      "checked": _vm._q(_vm.projeto.proposal.entityIsExecutioner, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.projeto.proposal, "entityIsExecutioner", "false")
      }
    }
  }), _vm._v(" Não\n                                  ")])])]), _vm._v(" "), (_vm.projeto.proposal.entityIsExecutioner === 'false') ? _c('div', [_c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Entidade")]), _vm._v(" "), _c('div', {
    staticClass: "form-group   col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    attrs: {
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingName),
      expression: "projeto.proposal.entityExecutingName"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Nome Entidade Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.projeto.proposal.entityExecutingName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "entityExecutingName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    class: {
      'has-error': _vm.errors.first('Representante legal')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante legal")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingProcurator",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingProcurator),
      expression: "projeto.proposal.entityExecutingProcurator"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Representante legal",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.projeto.proposal.entityExecutingProcurator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "entityExecutingProcurator", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CNPJ entidade executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCNPJ",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ entidade executora",
      "type": "text",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.projeto.proposal.entityExecutingCNPJ),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "entityExecutingCNPJ", $$v)
      },
      expression: "projeto.proposal.entityExecutingCNPJ"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Contato")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('E-mail executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingEmail",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingEmail),
      expression: "projeto.proposal.entityExecutingEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "E-mail executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.projeto.proposal.entityExecutingEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "entityExecutingEmail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone Executora')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fixo")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingPhone",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone Executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.entityExecutingPhone),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "entityExecutingPhone", $$v)
      },
      expression: "projeto.proposal.entityExecutingPhone"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Telefone celular da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGMOBILE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone celular")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingMobile",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "Telefone celular da executora",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.entityExecutingMobile),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "entityExecutingMobile", $$v)
      },
      expression: "projeto.proposal.entityExecutingMobile"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Telefone fax")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingFax",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "entityExecutingFax",
      "type": "text",
      "mask": ['(##) ####-####', '(##) #####-####']
    },
    model: {
      value: (_vm.projeto.proposal.entityExecutingFax),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "entityExecutingFax", $$v)
      },
      expression: "projeto.proposal.entityExecutingFax"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "col-md-4 col-sm-6 col-xs-12"
  }, [_c('legend', [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('CEP da executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCEP')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCEP",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "CEP da executora",
      "type": "text",
      "mask": ['#####-###']
    },
    model: {
      value: (_vm.projeto.proposal.entityExecutingCEP),
      callback: function($$v) {
        _vm.$set(_vm.projeto.proposal, "entityExecutingCEP", $$v)
      },
      expression: "projeto.proposal.entityExecutingCEP"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('UF executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGSTATE')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("UF")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingState",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingState),
      expression: "projeto.proposal.entityExecutingState"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "UF executora"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.projeto.proposal, "entityExecutingState", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "AC"
    }
  }, [_vm._v("AC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("AL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AM"
    }
  }, [_vm._v("AM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AP"
    }
  }, [_vm._v("AP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BA"
    }
  }, [_vm._v("BA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CE"
    }
  }, [_vm._v("CE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DF"
    }
  }, [_vm._v("DF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GO"
    }
  }, [_vm._v("GO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("MA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("MG")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("MS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("MT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("PA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PB"
    }
  }, [_vm._v("PB")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PE"
    }
  }, [_vm._v("PE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PI"
    }
  }, [_vm._v("PI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PR"
    }
  }, [_vm._v("PR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RJ"
    }
  }, [_vm._v("RJ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RN"
    }
  }, [_vm._v("RN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RO"
    }
  }, [_vm._v("RO")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RR"
    }
  }, [_vm._v("RR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RS"
    }
  }, [_vm._v("RS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("SC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SE"
    }
  }, [_vm._v("SE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SP"
    }
  }, [_vm._v("SP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TO"
    }
  }, [_vm._v("TO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Cidade da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGCITY')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingCity",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingCity),
      expression: "projeto.proposal.entityExecutingCity"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Cidade da Executora",
      "type": "text"
    },
    domProps: {
      "value": (_vm.projeto.proposal.entityExecutingCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "entityExecutingCity", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('Endereço da Executora')
    },
    attrs: {
      "ng-if": "regComProFormCtrl.isAval('ENTITYEXECUTINGADDRESS')"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    attrs: {
      "name": "proposal.entityExecutingAddress",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.entityExecutingAddress),
      expression: "projeto.proposal.entityExecutingAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Endereço da Executora",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.projeto.proposal.entityExecutingAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.projeto.proposal, "entityExecutingAddress", $event.target.value)
      }
    }
  })])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'FUNDACAO'),
      expression: "usuarioLogado.userType === 'FUNDACAO'"
    }],
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group col-md-12 required",
    class: {
      'has-error': _vm.errors.first('Projeto Duplicação')
    },
    attrs: {
      "uib-tooltip": "Projeto de duplicação"
    }
  }, [_c('div', {
    attrs: {
      "name": "proposal.duplicateProject",
      "approval": "regComProFormCtrl.approval",
      "state": "regComProFormCtrl.approvalState"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto.proposal.duplicateProject),
      expression: "projeto.proposal.duplicateProject"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Projeto Duplicação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.projeto.proposal, "duplicateProject", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.arvoreProjetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.projectNumber
      }
    }, [_vm._v(_vm._s(projeto.projectNumber + ' / ' +
      projeto.projectName) + "\n                                      ")])
  }), 0)])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(8), _vm._v(" "), _c('objetivoEspecificoOld', {
    attrs: {
      "propsObjetivos": _vm.projeto.proposal.objectives
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    ref: "metas",
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto',
      "name": "metas",
      "id": "metas"
    }
  }, [_vm._m(9), _vm._v(" "), _c('metasOld', {
    attrs: {
      "propsObjetivos": _vm.projeto.proposal.objectives
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    ref: "atividades",
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto',
      "name": "atividades",
      "id": "atividades"
    }
  }, [_vm._m(10), _vm._v(" "), _c('atividadesOld', {
    attrs: {
      "meses": _vm.projeto.proposal.periods,
      "propsObjetivos": _vm.projeto.proposal.objectives
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "right",
      "padding-right": "18px"
    }
  }, [(_vm.mudarCro === 1) ? _c('button', {
    staticClass: "btn btn-bitbucket btn-flat",
    staticStyle: {
      "float": "right",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mudaVisaoOrc
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Orçamento\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mudarOrc === 1) ? _c('button', {
    staticClass: "btn btn-bitbucket btn-flat",
    staticStyle: {
      "float": "right",
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mudaVisaoCro
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cronograma\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.mudarOrc === 1) ? _c('div', {
    staticClass: "col-md-12 box-body",
    attrs: {
      "id": "grid_cronograma"
    }
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-left linha-abaixo-larga",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "texto-azul cabecalho",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recurso da Fundação e Parceiros\n                              Estratégicos\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoContratado))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Total contratado")])]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoSaldo))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Saldo disponível")])]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalFundacaoContratado - _vm.totalFundacaoSaldo) / _vm.totalFundacaoContratado))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Percentual executado")])])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('td', {
    staticClass: "a_direita texto-claro realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atingimento\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensCronogramaFundacao), function(item) {
    return _c('tr', {
      attrs: {
        "title": "Previsto do " + item.Item_Periodo_Inicio + "º ao " + item.Item_Periodo_Inicio + "º mês do projeto. Contratado:  Quantidade " + item.Qtde_orcado + "  e  Valor Total  R$ " + _vm.formatarNumero(item.Valor_orcado, "moeda")
      }
    }, [_c('td', {
      staticClass: "linha-abaixo-larga"
    }, [_c('span', {
      staticClass: "texto-claro ng-binding"
    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao))]), _c('br'), _c('span', {
      staticClass: "ng-binding"
    }, [_vm._v("#" + _vm._s(item.Id_item) + "   - " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), _c('td', {
      staticClass: "centralizado linha-abaixo-larga ng-binding"
    }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
      staticClass: "a_direita linha-abaixo-larga ng-binding"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "a_direita linha-abaixo-larga"
    }, [_c('span', {
      staticClass: "percentual ng-binding"
    }, [_vm._v(_vm._s(_vm._f("percentage")(((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado))))]), (((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado) > 0.99) ? _c('span', {
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green"
      }
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', [_c('td', {
    staticClass: "text-left linha-abaixo-larga",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "texto-azul cabecalho",
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Recurso de Contrapartida de Entidade\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoContratadoContrapartida))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Total contratado")])]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totalFundacaoSaldoContrapartida))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Saldo disponível")])]), _vm._v(" "), _c('div', {
    staticClass: "div-esquerda ng-binding"
  }, [_vm._v(_vm._s(_vm._f("percentage")((_vm.totalFundacaoContratadoContrapartida - _vm.totalFundacaoSaldoContrapartida) / _vm.totalFundacaoContratadoContrapartida))), _c('br'), _c('span', {
    staticClass: "texto-esmaecido"
  }, [_vm._v("Percentual executado")])])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('td', {
    staticClass: "a_direita texto-claro realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Atingimento\n                          ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.itensCronogramaContrapartida), function(item) {
    return _c('tr', {
      attrs: {
        "title": "Previsto do " + item.Item_Periodo_Inicio + "º ao " + item.Item_Periodo_Inicio + "º mês do projeto. Contratado:  Quantidade " + item.Qtde_orcado + "  e  Valor Total  R$ " + _vm.formatarNumero(item.Valor_orcado, "moeda")
      }
    }, [_c('td', {
      staticClass: "linha-abaixo-larga"
    }, [_c('span', {
      staticClass: "texto-claro ng-binding"
    }, [_vm._v(_vm._s(item.Item) + " - " + _vm._s(item.Item_Descricao))]), _c('br'), _c('span', {
      staticClass: "ng-binding"
    }, [_vm._v("#" + _vm._s(item.Id_item) + "   - " + _vm._s(item.Item_Observacao))])]), _vm._v(" "), _c('td', {
      staticClass: "centralizado linha-abaixo-larga ng-binding"
    }, [_vm._v(_vm._s(item.Qtde_saldo))]), _vm._v(" "), _c('td', {
      staticClass: "a_direita linha-abaixo-larga ng-binding"
    }, [_vm._v(_vm._s(_vm._f("real")(item.Valor_saldo)) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticClass: "a_direita linha-abaixo-larga"
    }, [_c('span', {
      staticClass: "percentual ng-binding"
    }, [_vm._v(_vm._s(_vm._f("percentage")(((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado))))]), (((item.Valor_orcado - item.Valor_saldo) / item.Valor_orcado) > 0.99) ? _c('span', {
      staticClass: "fa fa-check",
      staticStyle: {
        "color": "green"
      }
    }) : _vm._e()])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.mudarCro === 1) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(15), _vm._v(" "), _c('cronogramaOld', {
    key: _vm.componentKey,
    attrs: {
      "propsObjetivos": _vm.proposta.objectives,
      "atividades": _vm.atividades,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.periods,
      "projeto-duplicacao": _vm.proposta.duplicateProject,
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    },
    on: {
      "itemAdicionado": function($event) {
        _vm.proposta.objectives = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('visualiza-gantt-old', {
    attrs: {
      "idProjeto": _vm.proposta.idProjectErp,
      "tipoBarra": 'financeiro',
      "mostrarExecFinanc": true,
      "mostrarExecDeclarada": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    }
  }, [_c('br'), _vm._v(" "), (this.$root.authorize('solicitacao-contrapartida-editar')) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": _vm.blockCounterpart,
      "uib-tooltip": "Redireciona para a tela de Solicitação de contrapartida",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onRedirect('COUNTERPART')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Comprovar contrapartida\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-pagamento-editar')) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "float": "right",
      "margin-right": "5px"
    },
    attrs: {
      "disabled": _vm.blockPayment,
      "uib-tooltip": "Redireciona para a tela de Solicitação de pagamento/ressarcimento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onRedirect('PAYMENT')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Solicitar pagamento/ressarcimento\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(16), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.parcelasAdiantamentoExibicao,
      "fields": _vm.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "plot",
      fn: function(row) {
        return [_vm._v("\n                            " + _vm._s(row.item.plot) + "\n                            "), (row.item._mista) ? _c('span', {
          staticStyle: {
            "display": "block",
            "font-size": "x-small"
          }
        }, [_vm._v("Parcela Mista")]) : _vm._e()]
      }
    }, {
      key: "value",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value.toLocaleString('pt-BR', _vm.formato)))]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12",
    staticStyle: {
      "text-align": "right",
      "padding-right": "10px"
    }
  }, [(this.$root.authorize('solicitacao-prestacaocontas-editar')) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "uib-tooltip": "Redireciona para a tela de Solicitação de prestação de contas",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onRedirect('ACCOUNTABILITY')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Realizar prestação de contas\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-devolucaoadiantamento-editar')) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "float": "right",
      "margin-right": "5px"
    },
    attrs: {
      "ng-disabled": "blockRefund",
      "uib-tooltip": "Redireciona para a tela de Solicitação de devolução de adiantamento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onRedirect('DEVOLUTION')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply-all",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Solicitar devolução de adiantamento\n                      ")]) : _vm._e(), _vm._v(" "), (this.$root.authorize('solicitacao-adiantamento-editar')) ? _c('button', {
    staticClass: "btn btn-primary btn-flat",
    staticStyle: {
      "float": "right",
      "margin-right": "5px"
    },
    attrs: {
      "ng-disabled": "blockAdvance",
      "uib-tooltip": "Redireciona para a tela de Solicitação de adiantamento",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onRedirect('ADVANCE')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-money",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Solicitar adiantamento\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('municipalizacaoOld', {
    attrs: {
      "proposta": _vm.projeto.proposal
    },
    on: {
      "municipioAdicionado": function($event) {
        _vm.proposta = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(18), _vm._v(" "), _c('cursosOld', {
    attrs: {
      "propsCursos": _vm.projeto.proposal.careers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(19), _vm._v(" "), _c('solenizacao', {
    attrs: {
      "propsSolenizacao": _vm.proposta.solemnizations
    },
    on: {
      "solenizacaoAdicionada": function($event) {
        _vm.proposta.solemnizations = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(20), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.projeto.proposal.documents,
      "documentTypes": []
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'visualiza-projeto'
    }
  }, [_vm._m(21), _vm._v(" "), _c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.projeto.proposal.documentStatements,
      "documentTypes": []
    }
  })], 1)]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'PARCEIRO_ESTRATEGICO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', {
    attrs: {
      "id": "teste",
      "name": "teste"
    }
  }, [_vm._m(22), _vm._v(" "), _c('historico-proposta-old', {
    attrs: {
      "proposta": _vm.proposta
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(this.$router.currentRoute.name === 'visualiza-projeto') ? _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista de\n                      projetos\n                    ")]) : _vm._e()])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Acompanhamento do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Alterações no Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações introdutórias")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Público-alvo")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Equipe do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações Gerais")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Entidade executora")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Projeto de duplicação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Objetivo Específico")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Metas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Atividades")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "centralizado texto-claro realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Quantidade"), _c('br'), _vm._v("Saldo\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "centralizado realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "texto-claro"
  }, [_vm._v("Saldo"), _c('br'), _vm._v("Financeiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "centralizado texto-claro realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Quantidade"), _c('br'), _vm._v("Saldo\n                          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "centralizado realcado linha-abaixo-larga",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('span', {
    staticClass: "texto-claro"
  }, [_vm._v("Saldo"), _c('br'), _vm._v("Financeiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma Físico-Financeiro")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Parcela de Adiantamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Municípios - Locais de execução")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cursos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Solenização")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Declaração de Adimplência e Inexistência de Outras Fontes:")])]), _vm._v(" "), _c('label', [_vm._v("Na qualidade de representante legal do proponente, declaro para fins de prova junto à\n                            Fundação Banco do Brasil, não contar com\n                            outras fontes de recursos para as mesmas despesas custeadas pela Fundação Banco do Brasil\n                            neste projeto.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de Aprovações:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aaf7ade2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projetos/VisualizaProjeto.vue
// module id = 2055
// module chunks = 1